import React, { FC } from 'react';
import styled from 'styled-components';
import { FormattedMessage } from 'react-intl';
import { globalTheme } from '@cld/component-theme';
import { website } from '@cld/typography';
import { getAssetUrl } from '../../../../utils';
import { messages } from '../../../../i18n';
import { Logo } from '../../../common/Logo';

const Root = styled.div`
  min-width: calc(${globalTheme.spacing.lg} * 23);
  display: flex;
  justify-content: center;
  align-items: center;
  background-image: url(${getAssetUrl('login-modal/oval.svg')});
  background-color: ${globalTheme.palette.primary};
  
  ${Logo} {
    height: calc(${globalTheme.spacing.lg} + ${globalTheme.spacing.xxs});
    margin-bottom: ${globalTheme.spacing.md};
  }
`;

const Container = styled.div`
  width: calc(${globalTheme.spacing.lg} * 19);
`;

const Heading = styled.h2`
  ${website.headlines.xl.contrastInvert};
`;

const Contents = styled.p`
  ${website.brandText.lg.contrastInvert};
`;

export const Intro: FC = () => (
  <Root>
    <Container>
      <Logo />
      <Heading>
        <FormattedMessage {...messages['loginModal.intro.heading']} />
      </Heading>
      <Contents>
        <FormattedMessage {...messages['loginModal.intro.text']} />
      </Contents>
    </Container>
  </Root>
);
